export default {
    primary: '#000000',
    secondary: '#fefc8d',
    background: '#EEEEEE'
}
